import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { AppDownloadButton } from "./AppDownloadButton";
import { EASE } from "./Motion";

export const PricingCard = ({ plan, delay = 0 }) => {
  const hot = plan.popular;
  return (
    <motion.article
      data-testid={`pricing-card-${plan.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={`relative flex flex-col rounded-card border p-7 lg:p-9 transition-[border-color,box-shadow] duration-500 ${hot ? "border-pa-orange bg-pa-surface shadow-glow-lg" : "border-white/10 bg-pa-bg hover:border-pa-orange/50 hover:shadow-glow"}`}
    >
      <div className="flex h-7 items-center justify-between">
        <span className="font-mono text-xs text-pa-dim">{plan.index}</span>
        {hot && (
          <span data-testid="pricing-popular-badge" className="bg-pa-orange px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-pa-black">Most popular</span>
        )}
      </div>
      <h3 className="mt-8 font-display text-4xl uppercase leading-none text-pa-ink">{plan.name}</h3>
      <p className="mt-6 flex items-baseline gap-2">
        <span data-testid={`pricing-price-${plan.id}`} className="font-display text-7xl leading-none text-pa-ink">{plan.price}</span>
        <span className="text-sm text-pa-muted">/ month</span>
      </p>
      <p className="mt-4 min-h-[48px] text-[15px] leading-relaxed text-pa-muted">{plan.blurb}</p>
      <ul className="mt-8 flex-1 space-y-3 border-t border-white/10 pt-8">
        {plan.features.map((f) => (
          <li key={f} className="flex gap-3 text-[15px] text-pa-ink">
            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${hot ? "text-pa-orange" : "text-pa-muted"}`} aria-hidden="true" />
            {f}
          </li>
        ))}
      </ul>
      <AppDownloadButton
        label={plan.cta}
        plan={plan.id}
        source={`pricing-${plan.id}`}
        testId={`pricing-select-${plan.id}`}
        variant={hot ? "primary" : "ghost"}
        className="mt-10 w-full"
      />
    </motion.article>
  );
};
